/* eslint-disable no-prototype-builtins,no-restricted-syntax */
import moment from 'moment'
import _ from 'lodash'
import { sprintf } from 'printj'
import i18n from '@/libs/i18n'
import { isNetworkError } from '@/helpers/networkStatus'

const cloneNested = obj => _.cloneDeep(obj)
const randomPassword = () => Array(20)
  .fill('0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^&*()_-+=[]{}<>?')
  // eslint-disable-next-line no-mixed-operators
  .map(x => x[Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1) * x.length)])
  .join('')

const checkNested = (obj, level, ...rest) => {
  if (obj === undefined) return false
  if (rest.length === 0 && obj.hasOwnProperty(level)) return true
  return checkNested(obj[level], ...rest)
}

const strToDecimal = str => Number(Number(str).toFixed(2))

const isReadOnlyRequestError = err => ['get', 'head', 'options'].includes((err?.config?.method || '').toLowerCase())

const parseRequestError = err => {
  if (isNetworkError(err)) {
    // A dedicated flow (e.g. order workflow refresh) may already own the messaging
    // for this failure; avoid stacking a second, contradictory network toast.
    if (err?.networkErrorHandled) {
      return
    }

    window.toast.notify.warning(
      i18n.t('network.error.title'),
      i18n.t(isReadOnlyRequestError(err) ? 'network.error.read-description' : 'network.error.write-description'),
    )
    return
  }

  const response = err?.response?.data ?? err
  const fallbackErrors = err?.errors || err?.response?.errors
  const extractedErrors = response?.errors || fallbackErrors
  let hasDetailedErrors = false

  if (Array.isArray(extractedErrors?.errors)) {
    hasDetailedErrors = extractedErrors.errors.length > 0
  } else if (Array.isArray(extractedErrors)) {
    hasDetailedErrors = extractedErrors.length > 0
  }

  let message = response?.message || err?.message
  if (response?.messageFormat && typeof i18n.te === 'function' && i18n.te(response.messageFormat)) {
    const translatedFormat = i18n.t(response.messageFormat)
    message = Array.isArray(response?.messageArgs) && response.messageArgs.length > 0
      ? sprintf(translatedFormat, ...response.messageArgs)
      : translatedFormat
  } else if (message) {
    message = i18n.t(message)
  }

  if (message && !hasDetailedErrors) {
    window.toast.notify.danger(message)
  }

  const notifyFieldErrors = (children, parentPath = []) => {
    if (!children) return

    Object.keys(children).forEach(key => {
      const node = children[key]
      const path = [...parentPath, key]
      const label = path.map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ')

      if (Array.isArray(node?.errors)) {
        node.errors.forEach(errorMessage => window.toast.notify.warning(label, errorMessage))
      }

      if (node?.children) {
        notifyFieldErrors(node.children, path)
      }
    })
  }

  if (Array.isArray(extractedErrors)) {
    extractedErrors.forEach(errorMessage => window.toast.notify.warning('Błąd', errorMessage))
  } else if (Array.isArray(extractedErrors?.errors)) {
    extractedErrors.errors.forEach(errorMessage => window.toast.notify.warning('Błąd', errorMessage))
  } else if (extractedErrors) {
    const children = extractedErrors.children || extractedErrors
    notifyFieldErrors(children)
  }
}

const capitalizeFirstLetter = val => String(val).charAt(0).toUpperCase() + String(val).slice(1)
const empty = data => {
  if (typeof (data) === 'number' || typeof (data) === 'boolean') {
    return false
  }
  if (typeof (data) === 'undefined' || data === null) {
    return true
  }
  if (typeof (data.length) !== 'undefined') {
    return data.length === 0
  }
  let count = 0
  for (const i in data) {
    if (data.hasOwnProperty(i)) {
      count += 1
    }
  }
  return count === 0
}
const transformDatetimeFromHumanReadable = date => moment(date, 'YYYY-MM-DD HH:mm')
  .format('YYYY-MM-DDTHH:mm:ssZ')
const transformDatetimeToHumanReadable = date => moment(date, 'YYYY-MM-DDTHH:mm:ssZ')
  .format('YYYY-MM-DD HH:mm')
const transformDateToHumanReadablePretty = date => moment(date, 'YYYY-MM-DDTHH:mm:ssZ')
  .format('DD.MM.YYYY')
const transformDatetimeToHumanReadablePretty = date => moment(date, 'YYYY-MM-DDTHH:mm:ssZ')
  .format('DD.MM.YYYY HH:mm')
const sanitizeUsername = value => {
  if (value === null || value === undefined) {
    return ''
  }
  return value.toString().toLowerCase()
}
const isVehicleDeleted = vehicle => Boolean(vehicle && vehicle.deletedAt)

export {
  cloneNested,
  randomPassword,
  parseRequestError,
  isNetworkError,
  checkNested,
  empty,
  transformDatetimeFromHumanReadable,
  transformDatetimeToHumanReadable,
  transformDateToHumanReadablePretty,
  transformDatetimeToHumanReadablePretty,
  strToDecimal,
  capitalizeFirstLetter,
  sanitizeUsername,
  isVehicleDeleted,
}
